import { render, staticRenderFns } from "./DivideUnstressedVowelsPreview.vue?vue&type=template&id=f30400a2&lang=pug&"
import script from "./DivideUnstressedVowelsPreview.vue?vue&type=script&lang=js&"
export * from "./DivideUnstressedVowelsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports